/* eslint-disable no-template-curly-in-string */
export const DEFAULT_INVITE_EMAIL_TEMPLATE = {
  title: 'Invite Template for ${program.title}',
  subject: 'You\'re Invited: Would you like to collaborate with ${client.name}?',
  text: JSON.stringify({
    blocks: [
      {
        key: '1ehbe',
        text: 'Hi First Name,',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 3,
            length: 10,
            key: 0,
          },
        ],
        data: {

        },
      },
      {
        key: '2nk14',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '8r2u3',
        text: "This is User Name from Brand Name. I'm reaching out because we think you could be a great fit for our Project Name!",
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 8,
            length: 9,
            key: 1,
          },
          {
            offset: 23,
            length: 10,
            key: 2,
          },
          {
            offset: 102,
            length: 12,
            key: 3,
          },
        ],
        data: {

        },
      },
      {
        key: '6g04r',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'ar3ae',
        text: "If you are interested, please click the below link, review the project details, and submit an application. To ensure we are selecting the best people for this project, we're reviewing every application carefully and will be in touch if you are accepted.",
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'd2n5m',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '5b45o',
        text: 'Apply now: Project Landing Page URL',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 11,
            length: 24,
            key: 4,
          },
        ],
        data: {

        },
      },
      {
        key: '7j4tp',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'acf9v',
        text: 'Feel free to reach out if you have any questions. We hope you will consider collaborating with us!',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '17a4',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '4uph4',
        text: 'Best,',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '37h2h',
        text: 'User Name',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 0,
            length: 9,
            key: 5,
          },
        ],
        data: {

        },
      },
    ],
    entityMap: {
      0: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'MEMBER_FIELDS.${id}',
          },
        },
      },
      1: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'USER_NAME',
          },
        },
      },
      2: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'CLIENT_NAME',
          },
        },
      },
      3: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'PROJECT_TITLE',
          },
        },
      },
      4: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'PROJECT_CUSTOMLANDINGPAGEPATH',
          },
        },
      },
      5: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'USER_NAME',
          },
        },
      },
    },
  }),
};
